module.exports = __webpack_public_path__ + "img/3.68801a38.png";